import React from 'react';
import Utilities from '@util/Utilities';
import { useFieldContext } from '@app/site/_form';
import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/solid';
import { FieldErrors } from '@app/site/_form/field/FieldErrors';


type TextFieldProps = {
	placeholder?: string,
	label?: string,
	isLoading?: boolean,
	disabled?: boolean,
	extraClassName?: string,
	labelHint?: string,
	maxLength?: number,
}

export const PasswordField: React.FunctionComponent<TextFieldProps> = (props) => {
	const field = useFieldContext<string>();
	const [type, setType] = React.useState('password');

	const hasError = field.state.meta.isTouched && !field.state.meta.isValid;

	const renderField = () => {
		return <input type={type}
									className={Utilities.classNames(
										'block input min-w-0 grow pr-3 text-base sm:text-sm/6',
										Utilities.NVL(hasError, 'input-error'),
										Utilities.NVL(props.isLoading, 'input-isLoading'),
										Utilities.NVL(props.disabled, 'input-disabled'),
										Utilities.NVL(!!props.extraClassName, props.extraClassName!),
									)}
									disabled={props.disabled}
									maxLength={props.maxLength}
									placeholder={props.placeholder}
									value={field.state.value}
									onChange={(e) => field.handleChange(e.target.value)} />;
	};

	const renderEye = () => {
		return <a
			className="absolute inset-y-0 end-0 flex items-center z-20 px-3 cursor-pointer text-gray-400 rounded-e-md focus:outline-hidden focus:text-blue-600 hover:text-blue-600"
			onClick={() => setType(type === 'password' ? 'text' : 'password')}>
			{type == 'password' ? <EyeIcon className="w-5 h-5" /> : <EyeSlashIcon className="w-5 h-5" />}
		</a>;
	};

	return <div>
		<div className="flex justify-between">
			{!!props.label && <div className="label">{props.label}</div>}
			{!!props.labelHint ? <span className="text-xs leading-6 text-gray-500">{props.labelHint}</span> : ''}
		</div>
		<div className="mt-0.5">
			<div className="relative">
				{renderField()}
				{renderEye()}
			</div>
		</div>
		<FieldErrors meta={field.state.meta} />
	</div>;
};